export const ANALYTICS_CONSENT_KEY = 'certy_analytics_consent';
export const CONSENT_KEY = 'certy_cookie_consent_v2';
export const CONSENT_CHANGED_EVENT = 'certy:tracking-consent-changed';
const MAX_AGE_MS = 180 * 24 * 60 * 60 * 1000;

export interface TrackingConsent {
  analytics: boolean;
  marketing: boolean;
  updatedAt: number;
}

export const readConsent = (): TrackingConsent | null => {
  try {
    const value = JSON.parse(window.localStorage.getItem(CONSENT_KEY) || 'null');
    if (value && typeof value.analytics === 'boolean' && typeof value.marketing === 'boolean'
      && typeof value.updatedAt === 'number' && value.updatedAt <= Date.now()
      && Date.now() - value.updatedAt < MAX_AGE_MS) return value;
  } catch { /* Unavailable storage means no optional tracking. */ }
  return null;
};

export const saveConsent = (analytics: boolean, marketing: boolean): TrackingConsent => {
  const consent = { analytics, marketing, updatedAt: Date.now() };
  try {
    window.localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, analytics ? 'granted' : 'denied');
  } catch { /* Keep the site usable when browser storage is blocked. */ }
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
  return consent;
};

export const clearTrackingCookies = (prefixes: string[]) => {
  const host = window.location.hostname.split('.');
  const domains = ['', window.location.hostname, ...host.map((_, i) => `.${host.slice(i).join('.')}`)];
  for (const cookie of document.cookie.split(';')) {
    const name = cookie.split('=')[0].trim();
    if (!prefixes.some(prefix => name.startsWith(prefix))) continue;
    for (const domain of domains) {
      document.cookie = `${name}=; Max-Age=0; path=/;${domain ? ` domain=${domain};` : ''} SameSite=Lax`;
    }
  }
};
